<template>
  <div class="about">
    <Banner :banner="banner" />
    <TypeMenu id="aboutmenu" :menu="type" class="aboutmenu" />
    <CompanyProfile ref="about1" />
    <Organization ref="about2" />
    <Companyculture ref="about3" />
    <Honor ref="about4" />
    <History ref="about5" />
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
import TypeMenu from '@/components/TypeMenu.vue'
import CompanyProfile from './CompanyProfile/CompanyProfile.vue'
import Organization from './Organization/Organization.vue'
import Companyculture from './Companyculture/Companyculture.vue'
import Honor from './Honor/Honor.vue'
import History from './History/History.vue'
import {WOW} from 'wowjs'
import Scrollbar from 'smooth-scrollbar';
import i18n from '@/plugins/i18n.js'
import { mapState } from 'vuex'
export default {
  components: {
    Banner,
    TypeMenu,
    CompanyProfile,
    Organization,
    Companyculture,
    Honor,
    History
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  data() {
    return {
      banner: {
        img: "/images/locals/aboutbanner.jpg",
        img_loading: "/images/locals_sm/aboutbanner.jpg",
        smallimg: "/images/locals/smallaboutbanner.jpg",
        smallimg_loading: "/images/locals_sm/smallaboutbanner.jpg",
        content: {
          cn: "东浩铸业",
          en: "ABOUT DONGHAO"
        }
      },
      type: [
        {
          ID: '1',
          CALLED: i18n.t('nav.about.submenu.Companyprofile')
        },
        {
          ID: '2',
          CALLED: i18n.t('nav.about.submenu.Organization')
        },
        {
          ID: '3',
          CALLED: i18n.t('nav.about.submenu.Corporateculture')
        },
        {
          ID: '4',
          CALLED: i18n.t('nav.about.submenu.Honor')
        },
        {
          ID: '5',
          CALLED: i18n.t('nav.about.submenu.History')
        }
      ],
      menuTop:0,
      scrollbar: ''
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData',
    lang: 'settype'
  },
  beforeRouteLeave (to, from, next) {
    //window.removeEventListener('scroll',this.scrollMenu)
    next()
  },
  mounted () {
    this.scrollbar=Scrollbar.init(document.getElementById('scroller-wrapper'));
    let scrollMenu=this.scrollMenu
    this.scrollbar.addListener((status) => {
      scrollMenu(status.offset.y)
    });
    //this.menuTop=document.getElementById('aboutmenu').offsetHeight
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.$nextTick(() => { 
      new WOW().init()
      this.fetchData()
    })
    // removeeventlistener
    //window.addEventListener('scroll',this.scrollMenu)
  },
  methods: {
    fetchData () {
      let tid = this.$route.params.tid || ''

      // 模拟锚点导航
      let offsetTop = 0
      switch (tid) {
        case '2':
          offsetTop = this.$refs.about2.$el.offsetTop - 90 || 0
          break
        case '3':
          offsetTop = this.$refs.about3.$el.offsetTop - 90 || 0
          break
        case '4':
          offsetTop = this.$refs.about4.$el.offsetTop - 90 || 0
          break
        case '5':
          offsetTop = this.$refs.about5.$el.offsetTop - 90 || 0
          break
        default:
          break
      }
      //window.scrollTo(0, offsetTop)
      //this.scrollTo(document.documentElement, { scrollTop: offsetTop },10,0.1)
      this.scrollbar.scrollTo(0,offsetTop,1000)
    },
    scrollTo(obj, json, interval, sp, fn) {
      clearInterval(obj.timer);
      obj.timer = setInterval(function () {
        //j ++;
        var flag = true;
        for (var arr in json) {
          var icur = 0;
          //k++;
          icur = obj.scrollTop;
          var speed = (json[arr] - icur) * sp;
          speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
          if (icur != json[arr]) {
            flag = false;
          }
          obj[arr] = icur + speed;
        }

        if (flag) {
          clearInterval(obj.timer);
          if (fn) {
            fn();
          }
        }
      }, interval);
    },
    scrollMenu(documentTop){
      let menu=document.getElementById('aboutmenu')
      let header=document.getElementById('header').offsetHeight
        if(!menu.classList.contains('fixed')){
          this.menuTop=menu.offsetTop
          //console.log(menuTop)
        }
        //let documentTop=document.documentElement.scrollTop
        //console.log(documentTop+'+'+header+'='+(documentTop+header),this.menuTop)
        //console.log(menu.classList.contains('fixed'))
        if(this.menuTop<documentTop+header){
          menu.classList.add('fixed')
          menu.style.marginTop=documentTop+header+'px'
        }else{
          menu.classList.remove('fixed')
          menu.style=""
        }
    },
    settype(){
      this.type[0].CALLED=i18n.t('nav.about.submenu.Companyprofile')
      this.type[1].CALLED=i18n.t('nav.about.submenu.Organization')
      this.type[2].CALLED=i18n.t('nav.about.submenu.Corporateculture')
      this.type[3].CALLED=i18n.t('nav.about.submenu.Honor')
      this.type[4].CALLED=i18n.t('nav.about.submenu.History')
    }
  }
}
</script>

<style scoped>
.aboutmenu{
  margin-top: 60px;
  margin-bottom: 50px;
  width: 100%;
  background-color: #fff;
}
.aboutmenu.fixed{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
</style>


